import { render, staticRenderFns } from "./ModalResultadoDiagnosticoPessoaOperacao.vue?vue&type=template&id=579790d0&scoped=true&lang=pug"
import script from "./ModalResultadoDiagnosticoPessoaOperacao.vue?vue&type=script&lang=js"
export * from "./ModalResultadoDiagnosticoPessoaOperacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579790d0",
  null
  
)

export default component.exports